import reduceReducers from 'reduce-reducers'
import closeModalReducer, { closeModal } from './closeModal'
import openModalReducer, { openModal } from './openModal'
import { save } from './save'

export { closeModal, openModal, save }

export default reduceReducers(closeModalReducer, openModalReducer)
